export enum ProductChangeOrder {
  Null = '',
  PublishingDateAsc = 'publishing_date asc',
  PublishingDateDesc = 'publishing_date desc',
  DeliveryDateAsc = 'delivery_date asc',
  DeliveryDateDesc = 'delivery_date desc'
}
